var _rect, _rect2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRawaajMonogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    role: "img",
    "aria-label": "Rawaaj Mall",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#cc9966"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 61,
    height: 61,
    rx: 14.5,
    fill: "none",
    stroke: "#fcb941",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 46,
    textAnchor: "middle",
    fontFamily: "Poppins, 'Segoe UI', Arial, sans-serif",
    fontSize: 40,
    fontWeight: 800,
    fill: "#ffffff"
  }, "R")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRawaajMonogram);
export default __webpack_public_path__ + "static/media/rawaaj-monogram.ad04ccbc9946ba1f5f6c74cf4ae45e8d.svg";
export { ForwardRef as ReactComponent };